import { Card } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";

export const RewardBalance = () => {
  const { rewardPoints, harvestMinimum, harvestRate, pendingRewards } = useBalances();
  return (
    <Card>
      <div className="space-y-1 mb-4">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">Reward Overview</h2>
      </div>
      <div className="space-y-0 divide-y divide-border/50">
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Harvest Points</span>
          <span className="text-base text-foreground font-mono whitespace-nowrap">
            {parseFloat(rewardPoints).toFixed(2)}
          </span>
        </div>
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Minimum Staked FRB</span>
          <span className="text-base text-foreground font-mono whitespace-nowrap">
            {parseFloat(harvestMinimum).toFixed(0)}
          </span>
        </div>
        <div className="flex items-center justify-between py-2.5 gap-3">
          <span className="text-sm text-muted-foreground">Points per harvest (daily)</span>
          <span className="text-base text-foreground font-mono whitespace-nowrap">
            {parseFloat(harvestRate).toFixed(0)}
          </span>
        </div>
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Pending Rewards</span>
          <span className="text-base text-foreground font-mono whitespace-nowrap">
            {parseFloat(pendingRewards).toFixed(0)} <span className="text-primary">FRB</span>
          </span>
        </div>
      </div>
    </Card>
  );
};
